export default __webpack_public_path__ + "static/media/Beastmaster's Rugged Choker.28ea643c.jpg";